module.exports = __webpack_public_path__ + "media/advanced colorectal cancer.4654849b.wav";